// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { Updater, } from '@/util/checkUpdate';
// import './config/rem';
import Vue from 'vue';
import ElementUI,{ alert,Loading, MessageBox } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import scroll from 'vue-seamless-scroll';
import axios from 'axios';
import store from './store';
import '../public/static/all-icon-integration/iconfont.css';
import "@/assets/style/common.scss"
import storage from "good-storage";
Vue.prototype.$storage = storage;
import common from "./components/store/common.js";
// 将axios绑定到全局Vue原型上
Vue.prototype.Common = common;
import VueCookies from 'vue-cookies';
Vue.use(VueCookies);
// Vue.prototype.$cookies = cookies;
Vue.prototype.$alert = alert;
Vue.prototype.$axios = axios;
axios.defaults.withCredentials = false;
Vue.use(scroll);
Vue.use(ElementUI);
Vue.config.productionTip = false;
import InBody from "./components/InBody";
Vue.component('InBody',InBody);
router.beforeEach((to, from, next) => {
  window.document.title = to.meta.title == undefined ? '默认标题' : to.meta.title
  if (to.meta.requireAuth) {
    let token = Cookies.get('access_token');
    let anonymous = Cookies.get('user_name');
    if (token) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      })

    }
  }
  next();
})

/* eslint-disable no-new */
const environment = process.env.NODE_ENV;

if (environment==='production') {
  const updateNew = new Updater({
    timer: 10000,
    requestUrl: '/v2-front/',
  })
  updateNew.on('update', () => {
    MessageBox.confirm('网站已有新版本更新，请问是否刷新体验最新版本。', '提醒', {
      type: 'warning',
    }).then(() => {
      location.reload();
    }).catch(err => err)
  })
  updateNew.on('no-update', () => {

  })
}

Vue.directive('noneImg',{
  bind(e,n,d){
    !d.data.attrs.src && (e.src=vue.$store.getters.getWebInfo.logo);
  }
});
Vue.filter('checkNull',(val,text)=>{
  return val?val+text:'';
});
sessionStorage.getItem('noUserInfo') && sessionStorage.removeItem('noUserInfo')
window.vue = new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})
window.openVueLoading = function () {
  window.loading = Loading.service({
    lock: true,
    text: "加载中...",
    spinner: "el-icon-loading",
    background: "rgba(255, 255, 255, .5)"
  });
}
window.openVueLoading();
window.closeVueLoading = function() {
  window.loading && window.loading.close &&window.loading.close();
}